import { HttpClient } from '@angular/common/http';

import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Inject, PLATFORM_ID, DOCUMENT, Injectable } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { environment } from '../environments/environment';
import { RuntimeService } from './shared/services/runtime.service';

@Injectable({ providedIn: 'root' })

export class TranslocoHttpLoader implements TranslocoLoader {
    protected readonly DEBUG: boolean = !environment.production;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        @Inject(DOCUMENT) private document: any,
        private http: HttpClient,
        private runtimeService: RuntimeService,
    ) {}

    getTranslation(lang: string) {
        let path = '/';
        if (isPlatformServer(this.platformId)) {
            const location = this.document?.location;
            const baseHref = this.document?.getElementsByTagName('base')?.[0]?.getAttribute('href') ?? '/';
            path = location?.hostname + (location?.port?.length && ![null, 80, 443].includes(location?.port) ? ':' + location.port : '') + baseHref;
            path = path.replace(/\/+/g, '/');
            path = location?.protocol + "//" + path;

            console.info("SSR I18n: " + path + 'assets/i18n/' + lang + '.json?v=' + this.runtimeService?.getBuild());
        }

        return this.http.get<Translation>(path + 'assets/i18n/' + lang + '.json?v=' + this.runtimeService?.getBuild());
    }
}
